import { useEffect, useRef, useState } from 'react';
import { MS_GS_CANVAS_WIDE_MIN_WIDTH } from '../../../../../../shared/constants.js';

const WIDE_CANVAS_MIN_WIDTH = MS_GS_CANVAS_WIDE_MIN_WIDTH;

export function useSolutionDom() {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const layoutContainerRef = useRef<HTMLDivElement>(null);
  // Independent from dropdownRef/isDropdownOpen above (the task-nav dropdown) — the language-use-group
  // membership picker is a separate popover that can be open at the same time.
  const groupPickerRef = useRef<HTMLDivElement>(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isGroupPickerOpen, setIsGroupPickerOpen] = useState(false);
  const [isCanvasNarrow, setIsCanvasNarrow] = useState(true);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
      if (groupPickerRef.current && !groupPickerRef.current.contains(event.target as Node)) {
        setIsGroupPickerOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const node = layoutContainerRef.current;
    if (!node) return;

    const updateLayoutMode = () => {
      const width = node.getBoundingClientRect().width;
      setIsCanvasNarrow(width < WIDE_CANVAS_MIN_WIDTH);
    };

    updateLayoutMode();
    const observer = new ResizeObserver(() => updateLayoutMode());
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return {
    refs: { dropdownRef, layoutContainerRef, groupPickerRef },
    state: { isDropdownOpen, isGroupPickerOpen, isCanvasNarrow },
    actions: { setIsDropdownOpen, setIsGroupPickerOpen, setIsCanvasNarrow },
  };
}
